// extracted by mini-css-extract-plugin
export default {"buttonContainer":"modalResetTicket_buttonContainer__XjQ7u"};